import { Head } from "@inertiajs/react";
import { Layout } from "@/components/Layout";

/*
 * The tester guide, rendered from docs/for-testers.md.
 *
 * A page rather than a file to send round because the things it explains keep
 * changing while we build, and a document that has been forwarded four times
 * cannot be corrected. The link stays the same and the content follows.
 */
export default function Guide({ html, updatedOn }: { html: string; updatedOn: string }) {
  return (
    <Layout>
      <Head title="Guide for testers" />

      {/* Our own markdown from the repo, not anything a member wrote. */}
      <article
        className="prose-guide max-w-2xl"
        dangerouslySetInnerHTML={{ __html: html }}
      />

      {/* Says how fresh it is, since the answers here change week to week and
          somebody reading a stale link should be able to tell. */}
      <p className="mt-10 max-w-2xl border-t border-neutral-200 pt-4 text-sm text-neutral-500 dark:border-neutral-800">
        Last updated {new Date(updatedOn).toLocaleDateString("en-GB", {
          day: "numeric", month: "long", year: "numeric",
        })}. Questions, or something here turned out to be wrong? Message Pavel.
      </p>
    </Layout>
  );
}
